import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './link.component.scss';
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link(element) {
        return _super.call(this, element) || this;
    }
    Link.prototype.init = function () { };
    Link.prototype.bindEvents = function () { };
    return Link;
}(Base));
export { Link };



//////////////////
// WEBPACK FOOTER
// ./components/link/link.component.ts
// module id = 398
// module chunks = 0